import { Box, Divider, Grid, Tab, Tabs, Typography, useMediaQuery } from '@mui/material';
import { PageTitle } from '../../../layoutPages/components/PageTitle';
import { CourseTab } from '../menuTab';
import { HaveImage, Paragraph } from '../../../layoutPages/containers/Paragraphs/Paragraph';
import { TabDefaultSetting } from '../../../layoutPages/defaultSetting';
import { DottedList } from '../../../layoutPages/containers/DottedList';
import { MainCard } from '../../../layoutPages/components/MainCard';
import { engMenuData } from '../../../data/SubjectMenu/engMenuData';

export function PageEngConcern() {

    const isPc = useMediaQuery('(min-width:600px)');

    let dottedListData = [
        "Develop students to be life-long learners who can face the challenges of the new socio-economic demands.",
        "Enhance innovative learning and teaching strategies through e-learning.",
        "Provide as many authentic opportunities for students to use English as possible through life wide learning activities in different levels.",
        "Enhance students’ writing abilities by integrating the Process Writing Approach and use of Writing Portfolio.",
        "Enhance students’ reading abilities through the Reading Success Program in P.1-3 and Advanced Reading Program in P.4-5. Students learn reading skills, phonics and sight words explicitly in P.1-3 whereas students in P.4-6 apply the reading skills they have learnt in context.",
        "Promote the use of Cooperative Learning and Drama in Education to enhance learning and teaching effectiveness.",
        "Engage students in the integrative use of language, application of knowledge and skills through Mini Project (P.3) and Theme-based Portfolios (P.4-6).",
        "Continuous professional development for teachers through workshops, sharing and networking with other schools.",
        "Continuous support to parents through parents’ workshop and online resources."
    ];

    return (
        <Grid container direction="row" justifyContent="center" alignItems="top" spacing={2}>
            <PageTitle title='Current Main Concerns' size='h3' />
            <Grid item xs={11} sm={10}>
                <CourseTab data={engMenuData}/>
                <MainCard src="http://www.pkps.edu.hk/img/teachplan/eng/concern/top2.jpg" noImgPopup={true} />

            </Grid>

            <Grid item xs={11} sm={10} sx={{ p: 2 }}>
                <DottedList data={dottedListData} variant="number" />
            </Grid>
            



        </Grid>
    )
}
